export enum RedirectActionEnum {
  MoveToLoginPage = 0,
  MoveToDashboard = 1,
  MoveToRegistration = 2,
  MoveToResetPassword = 3,
  Redirect = 4,
  MoveToSecuritySettings = 5,
  MoveToReset2Fa = 7,
  MoveToLinkExpired = 8,
  MoveToSelfRegistration = 9,
}
